import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { AxiosProxy } from '../../../../../api/axiosProxy/axiosProxy';
import { useNotifications } from '../../../../../hooks/utils/useNotifications';
import { captureExceptionWithMessage } from '../../../../../lib/sentry/captureExceptionWithMessage/captureExceptionWithMessage';

interface TriggerSbomBody {
  repositories: string[];
  organizationName?: string;
}

export const useTriggerGithubSbomGeneration = () => {
  const { t } = useTranslation();
  const { success, error } = useNotifications();
  const queryClient = useQueryClient();

  return useMutation(
    async (body: TriggerSbomBody) => {
      return AxiosProxy.post({ url: 'integration/github/sbom', body });
    },
    {
      onSuccess: (
        data: { errors: string[]; success: boolean },
        variables: TriggerSbomBody,
      ) => {
        if (data?.success) {
          queryClient.invalidateQueries(['integration-github']);
          success({
            title: t('page.userSettings.integrations.github.labels.generateNowTitle'),
            message: t(
              'page.userSettings.integrations.github.labels.generateNowDescription',
            ),
            autoClose: 3000,
          });
        } else {
          error({
            title: t(
              'page.userSettings.integrations.github.labels.generateNowErrorTitle',
            ),
            message: t(
              'page.userSettings.integrations.github.labels.generateNowErrorDescription',
            ),
            autoClose: 3000,
          });
        }
      },
      onError: (err: unknown) => {
        captureExceptionWithMessage(
          'Failed to generate GitHub organization repositories SBOMs',
          err,
        );
        error({
          title: t('page.userSettings.integrations.github.labels.generateNowErrorTitle'),
          message: t(
            'page.userSettings.integrations.github.labels.generateNowErrorDescription',
          ),
          autoClose: 3000,
        });
      },
    },
  );
};
